import "./modules/legacy_js";

import {
    updateProgressBar,
    generate_toc
} from "./modules/blog";

import {
    siteDimmer,
    headerScroll,
    toggleMobileMenu,
    toggleSearchBar,
    hideArrows
} from "./modules/header";

import { fixed_header } from "./modules/header_hire";
import { facetoverrides, generateSkeletonLines } from "./modules/facetwp";

import { toggle_mobile_filter, articles_section_case_study } from "./modules/categories";

import { sendConversionUrl } from "./modules/hubspot";

/**
 * This function looks for data init in the page and grabs the source and executes, initializers
 * @private
 */
function dataInit() {
    const templateUrl = wp?.templateUrl ?? null;
    // check for path to template
    if (!templateUrl) {
        return;
    }

    function parseJavascriptName(scriptName) {
        return `${templateUrl}/dist/js/components/${scriptName}/${scriptName}.js`;
    }

    const componentsSet = new Set()
    const components = document.querySelectorAll("[data-ig-component]") || null

    if (!components) return

    function createScript(data) {

        if (!dataInit) {
            return;
        }

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = data;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    components.forEach((component) => {
        componentsSet.add(component?.dataset?.igComponent)
    })

    componentsSet.forEach((component) => {
        let data = parseJavascriptName(component)
        createScript(data);
    })
}

function brand() {
    const year = new Date();
    console.log(
    `%c
     ___           _       _     _    ____ _       _           _
    |_ _|_ __  ___(_) __ _| |__ | |_ / ___| | ___ | |__   __ _| |
     | || '_ \\/ __| |/ _\` | '_ \\| __| |  _| |/ _ \\| '_ \\ / _\` | |
     | || | | \\__ \\ | (_| | | | | |_| |_| | | (_) | |_) | (_| | |
    |___|_| |_|___/_|\\__, |_| |_|\\__|\\____|_|\\___/|_.__/ \\__,_|_|
                     |___/
                        insightglobal.com © ${year.getFullYear()}
    `,
    'font-family: monospace; color: #00d6f2; text-align: center;'
    );
}

document.addEventListener("DOMContentLoaded", () => {
    brand()
    siteDimmer()
    headerScroll()
    toggleMobileMenu()
    dataInit()
    updateProgressBar()
    fixed_header()
    facetoverrides()
    generateSkeletonLines()
    toggle_mobile_filter()
    toggleSearchBar()
    generate_toc('h2')
    articles_section_case_study()
    hideArrows()
    sendConversionUrl()
})
